import React from 'react';
import PatternDisplay from '../subcomponents/PatternDisplay';
import { getPresetPatterns } from '../../utils.js';
import '../../sass/bingopattern.scss';

class Patterns extends React.Component {

  render() {
    const patterns = getPresetPatterns();
    return(
      <section id="pattern-list">
        <div className="container row">
          <div className="col padding-xxlg">
            <h1>Patterns
                <button className="primaryBtn print-btn" onClick={() => {window.print();return false;}}>PRINT</button>
            </h1>
            <div className="container">
              <div className="row patterns">
                {patterns.map(pattern => {
                  return(
                    <div key={pattern.label} className="pattern-block col">
                      <PatternDisplay pattern={pattern}></PatternDisplay>
                    </div>
                  )
                })}
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  }
}
export default Patterns;